import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Tabs } from "antd";
import styled from "styled-components";
import mainimage from "../image/textilebgonly.png";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const Container = styled.div`
  background: #2c5f62;
  padding: 60px 20px;
  text-align: center;
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 10px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

const BackgroundImage = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  opacity: 0.3;
  z-index: 1;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .ant-tabs-tab {
    font-weight: bold;
    color: white !important;
    font-size: 16px;
    padding: 8px 16px;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: white !important;
    text-shadow: none !important;
  }

  .ant-tabs-ink-bar {
    background-color: white !important;
  }

  @media (max-width: 768px) {
    .ant-tabs-tab {
      font-size: 14px;
    }
  }
`;

const TextContainer = styled.div`
  border-radius: 10px;
  display: inline-block;
  color: white;
  margin-bottom: -33px;
  word-break: break-word;
  white-space: normal;
`;

const FeatureBox = styled.div`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  height: 100%;
  text-align: left;
  color: white;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
  }

  b {
    font-size: 18px;
    font-family: "Poppins", sans-serif;
  }

  p {
    font-size: 15px;
    line-height: 1.6;
    word-break: break-word;
  }

  @media (max-width: 768px) {
    padding: 16px;

    b {
      font-size: 16px;
    }

    p {
      font-size: 14px;
    }
  }
`;

const features = [
  {
    title: "Industry-Specific Expertise",
    desc: "Our team understands the unique procurement needs and operational challenges across your industry.",
  },
  {
    title: "Trusted Supplier Network",
    desc: "Work with thoroughly vetted wholesalers, manufacturers, and exporters to ensure consistent quality and delivery.",
  },
  {
    title: "Affordable Wholesale Rates",
    desc: "Unlock exclusive access to industry-best pricing, volume discounts, and value-added deals.",
  },
  {
    title: "Global Access, Local Expertise",
    desc: "We operate on a global scale, but provide regional support for efficient communication and delivery.",
  },
  {
    title: "All-in-One Wholesale Platform",
    desc: "Manage procurement across multiple industries from a single reliable platform — hassle - free and efficient.",
  },
];

const Section4 = () => {
  const [selectedCategory, setSelectedCategory] = useState("Option1");

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Container>
      <BackgroundImage src={mainimage} alt="Background" />

      <ContentWrapper>
        <motion.div whileHover={{ scale: 1.02 }} data-aos="fade-up">
          <TextContainer>
            <Title
              style={{
                color: "white",
                fontSize: "36px",
                fontFamily: "Poppins, sans-serif",
                marginBottom: 10,
                letterSpacing: "0.5px",
                wordSpacing: "1px",
              }}
            >
              Why Choose Us
            </Title>

            <StyledTabs
              defaultActiveKey="Option1"
              centered
              onChange={(key) => setSelectedCategory(key)}
            >
              {/* Future Tabs */}
              {/* <TabPane tab="Option1" key="Option1" /> */}
            </StyledTabs>

            <Paragraph
              style={{
                color: "white",
                fontSize: "17px",
                fontFamily: "Poppins, sans-serif",
                marginTop: 16,
                letterSpacing: "0.3px",
                wordSpacing: "0.5px",
              }}
            >
              {/* Optional introductory text */}
            </Paragraph>
          </TextContainer>
        </motion.div>

        <motion.div whileTap={{ scale: 1.0 }} data-aos="fade-up">
          <div style={{ marginTop: "50px" }}>
            <Row gutter={[24, 60]} justify="center">
              {features.map((item, idx) => (
                <Col xs={24} sm={24} md={12} lg={8} xl={8} key={idx}>
                  <FeatureBox>
                    <Paragraph
                      style={{
                        fontSize: "16px",
                        marginBottom: "8px",
                        color: "white",
                        fontFamily: "Poppins, sans-serif",
                        letterSpacing: "0.4px",
                        wordSpacing: "0.6px",
                      }}
                    >
                      ✅ <b>{item.title}</b>
                    </Paragraph>
                    <Paragraph
                      type="secondary"
                      style={{
                        color: "white",
                        fontSize: "15px",
                        fontFamily: "Poppins, monospace",
                        letterSpacing: "0.2px",
                        wordSpacing: "0.4px",
                      }}
                    >
                      {item.desc}
                    </Paragraph>
                  </FeatureBox>
                </Col>
              ))}
            </Row>
          </div>
        </motion.div>
      </ContentWrapper>
    </Container>
  );
};

export default Section4;
